<template>
     <Row>
        <Col class="content section_list" span="12">
            <Form ref="data"  :model="data" :rules="ruleValidate" :label-width="80">
                <FormItem label="课程名称" prop="cName">
                    <Input v-model="data.cName" placeholder="请输入课程名称..."></Input>
                </FormItem>
                <FormItem label="课程简介" prop="cDesc">
                    <Input v-model="data.cDesc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入课程简介..."></Input>
                </FormItem>
                <FormItem label="封面图" prop="coverUrl">
                    <Input v-model="data.coverUrl" placeholder="请填写封面图url..."></Input>
                </FormItem>
                <FormItem label="标签" prop="cate">
                    <Input v-model="data.cate" placeholder="请填写课程标签"></Input>
                </FormItem>
                <FormItem label="顺序" prop="seq">
                    <Input v-model="data.seq" placeholder="顺序..."></Input>
                </FormItem>
                <FormItem>
                <Button type="primary" @click="handleSubmit('data')">{{cid?'保存':'添加'}}课程</Button>
                    <Button @click="handleReset('data')" style="margin-left: 8px">返回</Button>
                </FormItem>
            </Form>
        </Col>
    </Row>
    
</template>
<script>
import http from "../../libs/http.js"
    export default {
        data () {
            return {
                cid:this.$route.query.cid||'',
                data: {
                    cName: '',
                    cDesc: '',
                    coverUrl: '',
                    cate:'',
                },
                ruleValidate:{
                    cName: [
                        { required: true, message: '课程名不能为空', trigger: 'blur' },
                    ],
                    cDesc: [
                        { required:false}
                    ],
                    coverUrl: [
                        { required:false}
                    ],
                    cate: [
                        { required:false}
                    ],
                    seq: [
                        { required:false}
                    ],
                }
            }
        },
        methods:{
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.editCourse()
                        // 
                    } else {
                        this.$Message.error('请验证完整性');
                    }
                })
            },
            editCourse(){
                let _this = this;
                let sendData = _this.data
                if (_this.cid) {
                    sendData.cId = _this.cid
                }
                http.post('/course/edit',{
                    data:JSON.stringify(sendData)
                })
                .then(res => {
                    if (res) {
                        this.$Message.success(_this.cid?'修改课程成功':'添加课程成功');
                        this.$router.go(-1)
                    }
                })
                .catch(error => {
                    console.error(error)
                });
            },
            handleReset (name) {
                this.$refs[name].resetFields();
                this.$router.go(-1)
            }
        },
    }
</script>